<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(100vh - 165px)"
          :class="$vuetify.breakpoint.xlOnly ? 'max-h70vh' : ''">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            :class="$vuetify.breakpoint.xlOnly ? 'max-h70vh' : ''">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              :class="$vuetify.breakpoint.xlOnly ? 'max-h70vh' : ''">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('header.study') }}</h1>
                          <router-link
                            class="text-decoration-none"
                            :to="{ name: 'Coursereg' }">
                            <div class="d-flex align-center">
                              <h2 class="white--text text-md-h4 mb-3 link-list-style-dot">
                                {{ $t('title.regcourse') }}
                              </h2>
                            </div>
                          </router-link>
                          <router-link
                            class="text-decoration-none"
                            :to="{ name: 'Courseint' }">
                            <div class="d-flex align-center">
                              <h2 class="white--text text-md-h4 mb-3 link-list-style-dot">
                                {{ $t('title.intcourse') }}
                              </h2>
                            </div>
                          </router-link>
                          <router-link
                            class="text-decoration-none"
                            :to="{ name: 'Coursecoop' }">
                            <div class="d-flex align-center">
                              <h2 class="white--text text-md-h4 mb-3 link-list-style-dot">
                                {{ $t('title.coopcourse') }}
                              </h2>
                            </div>
                          </router-link>
                          <router-link
                            class="text-decoration-none"
                            :to="{ name: 'Courserpl' }">
                            <div class="d-flex align-center">
                              <h2 class="white--text text-md-h4 mb-3 link-list-style-dot">
                                {{ $t('title.rplcourse') }}
                              </h2>
                            </div>
                          </router-link>
                          <router-link
                            class="text-decoration-none"
                            :to="{ name: 'Coursespe' }">
                            <div class="d-flex align-center">
                              <h2 class="white--text text-md-h4 mb-3 link-list-style-dot">
                                {{ $t('title.specialcourse') }}
                              </h2>
                            </div>
                          </router-link>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="12" v-if="$i18n.locale === 'en'">
              <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                Enrollment
              </h2>
              <p class="text-justify">
                For detail of information for enrollment, please click
                <router-link :to="{ name: 'NewsDetail', query: { berita: 25 } }">
                  this link
                </router-link>
              </p>
            </v-col>
            <v-col cols="12" md="12" v-if="$i18n.locale === 'id'">
              <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                Pendaftaran
              </h2>
              <p class="text-justify">
                Untuk detail informasi pendaftaran, silakan klik
                <router-link :to="{ name: 'NewsDetail', query: { berita: 25 } }">
                  tautan ini
                </router-link>
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <!-- <v-divider></v-divider> -->
    <v-container fluid fill-height class="py-10 min-height-pages bacground-gray">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('../assets/study-withus.jpg')"
                position="top">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.studywithus') }}
                </v-card-title>
              </v-img>
              <v-card-text>
                <div class="black--text text--primary">
                  <div v-if="$i18n.locale === 'en'">
                    We are committed to assisting our students in shaping their future, achieving their goals, and landing their dream jobs through our interactive and innovative learning programs. We offer regular classes, cooperation classes, RPL classes, and specialization classes. You can tailor your courses to suit your needs and purposes.
                  </div>
                  <div v-if="$i18n.locale === 'id'">
                    Kami berkomitmen untuk membantu siswa kami dalam membentuk masa depan mereka, mencapai tujuan mereka, dan mendapatkan pekerjaan impian mereka melalui program pembelajaran interaktif dan inovatif kami. Kami menawarkan kelas reguler, kelas kerjasama, kelas RPL, dan kelas spesialisasi. Anda dapat menyesuaikan kursus Anda sesuai dengan kebutuhan dan tujuan Anda.
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('../assets/study-jimbaran.jpg')"
                position="top">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.jimbaranarea') }}
                </v-card-title>
              </v-img>
              <v-card-text>
                <div class="black--text text--primary">
                  <div v-if="$i18n.locale === 'en'">
                    Our campus is located in the vibrant Jimbaran area, which is only 10 minutes from Ngurah Rai Airport, 10 minutes from Nusa Dua, three minutes from Garuda Wisnu Kencana, and 20 minutes from Uluwatu Temple.
                  </div>
                  <div v-if="$i18n.locale === 'id'">
                    Kampus kami terletak di kawasan Jimbaran yang ramai, yaitu hanya 10 menit dari Bandara Ngurah Rai, 10 menit dari Nusa Dua, tiga menit dari Garuda Wisnu Kencana, dan 20 menit dari Pura Uluwatu.
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="d-flex">
            <v-card
              class="d-flex flex-column w100">
              <v-img
                class="white--text align-end flex-grow-0 flex-shrink-1"
                height="225px"
                :src="require('../assets/study-visitus.jpg')"
                position="top">
                <v-card-title class="card-title-block font-weight-bold">
                  {{ $t('title.visitus') }}
                </v-card-title>
              </v-img>
              <v-card-text>
                <div class="black--text text--primary">
                  <div v-if="$i18n.locale === 'en'">
                    We welcome you anytime. Before you even start your courses, you can visit our campus with or without your parents. We will guide you to experience the academic ambiance at our facilities and meet our academic staff and current students.
                  </div>
                  <div v-if="$i18n.locale === 'id'">
                    Kami menyambut Anda kapan saja. Bahkan sebelum Anda memulai kursus Anda, Anda dapat mengunjungi kampus kami dengan atau tanpa orang tua Anda. Kami akan memandu Anda untuk merasakan suasana akademik di fasilitas kami dan bertemu dengan staf akademik dan siswa kami saat ini.
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <!-- <v-divider></v-divider> -->
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold sub-title-page">
            {{ $t('title.newsedu') }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="newslist.length">
        <v-col
          class="d-flex"
          cols="12"
          md="4"
          v-for="(news, i) in newslist"
          :key="i">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="news.urlpic"
              aspect-ratio="16/9">
            </v-img>
            <v-card-subtitle>
              <h1 class="title font-weight-bold mb-3">
                <router-link class="text-decoration-none text-ellipsis--2"
                  :title="news.judul_berita"
                  :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                  {{ news.judul_berita }}
                </router-link>
              </h1>
              <div class="d-flex">
                <v-chip
                  class="mr-1"
                  color="deep-orange"
                  small
                  dark
                  :title="news.tgl_berita">
                  <v-icon left small>
                    mdi-update
                  </v-icon>
                  <timeago :datetime="news.tgl_berita"></timeago>
                </v-chip>
                <v-chip
                  class="mr-1"
                  color="primary"
                  small
                  dark>
                  <v-icon left small>
                    mdi-alpha-c-circle
                  </v-icon>
                  {{ news.cat_berita }}
                </v-chip>
                <v-spacer></v-spacer>
                <ShareNetwork
                  network="facebook"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="indigo">
                    mdi-facebook
                  </v-icon>
                </ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="green">
                    mdi-whatsapp
                  </v-icon>
                </ShareNetwork>
              </div>
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div v-html="news.prev_berita"></div>
            </v-card-text>
            <v-card-actions v-if="false">
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pendidikan' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!newslist.length">
        <v-col cols="12" md="12">
          <div class="grey--text my-2">
            Berita pada kategori ini tidak ditemukan.
          </div>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pendidikan' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Study',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    newslist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/cov-study.jpg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getBerita();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.updateLanguage();
      }
    },
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      // console.log(props);
      return this.baseurl + '' + props.href;
    },
    updateLanguage() {
      this.getBerita();
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'pendidikan';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getJeniskerja() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.addjeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddjeniskerja.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'pekerjaan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getJeniskerja();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jeniskerja') {
        this.dmodal.jeniskerja = false;
      } else {
        this.dmodal.jeniskerja = false;
      }
    },
    editJeniskerja(item) {
      this.dmodal.jeniskerja = true;
      this.dmodaldata.jeniskerja = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.dmodaldata.jeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jeniskerja.nama_kerja + '" berhasil diubah!';
                  this.getJeniskerja();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
